import audioCore from '.';

/**
 *
 * @param {AudioBuffer} audioBuffer
 */
const createAudioObject = (audioBuffer) => {
    const { context, master } = audioCore;

    /** @type {AudioBufferSourceNode} */
    let source = null;
    let loop = false;
    let sourceOffset = 0;
    let startedAt = 0;

    const gainNode = context.createGain();
    gainNode.connect(master);

    const handleSourceEnded = () => {
        if (context.currentTime - startedAt + sourceOffset >= audioBuffer.duration) {
            sourceOffset = 0;
        }
        source = null;
    };

    return {
        get duration() {
            return audioBuffer.duration;
        },
        get loop() {
            return loop;
        },
        set loop(value) {
            loop = value;
            if (source) {
                source.loop = value;
            }
        },
        get volume() {
            return gainNode.gain.value;
        },
        set volume(value) {
            gainNode.gain.value = value;
        },
        get currentTime() {
            if (!this.playing) {
                return sourceOffset;
            }
            return context.currentTime - startedAt + sourceOffset;
        },
        get playing() {
            return source != null;
        },
        get node() {
            return gainNode;
        },
        play(playbackRate = null) {
            if (this.playing) {
                if (__ENV__ === 'local' || __ENV__ === 'development') {
                    console.warn('Audio already playing');
                }
                return { success: false, obj: this };
            }

            source = context.createBufferSource();
            source.buffer = audioBuffer;
            if (playbackRate) {
                source.playbackRate.value = playbackRate;
            }
            source.loop = loop;
            source.onended = () => {
                handleSourceEnded();
                this.onEndedEvent();
            };
            source.connect(gainNode);
            source.start(0, sourceOffset);
            startedAt = context.currentTime;
            return { success: true, obj: source };
        },
        seek(/* time */) {
            let wasPlaying = this.playing;
            if (wasPlaying) {
                source.stop();
            }

            // offset = time;
            if (wasPlaying) {
                this.play();
            }
        },
        pause() {
            if (source) {
                sourceOffset = this.currentTime % this.duration;
                source.stop();
            }
        },
        stop() {
            sourceOffset = 0;
            if (source) {
                source.stop();
            } else {
                if (__ENV__ === 'local' || __ENV__ === 'development') {
                    console.warn('Stopped called on audio object while it was not playing.');
                }
            }
        },
        onEndedEvent() {
            if (this.onEnded) this.onEnded(this);
        },
        /**
         * Not really a clone as it doesn't actually copy any of the properties (eg loop)
         */
        clone() {
            return createAudioObject(audioBuffer);
        },
    };
};

export default createAudioObject;
